import { useTheme } from '../contexts/ThemeContext';

/**
 * Resolves an entry kind's accent classes, falling back to the active theme
 * when the kind defines none.
 *
 * Expenses have `accent: null` and so keep following the user's theme exactly
 * as they did before income existed; income pins itself to green.
 *
 * Every value returned is a complete Tailwind class token, safe to join with a
 * space at the call site (`bg-gradient-to-r ${accent.button}`) but never to
 * build a token from.
 *
 * @param {import('../constants/entryKinds').EntryKind} kind
 * @returns {{ button: string, buttonHover: string, shadow: string,
 *             chip: string, heroBg: string, textMuted: string }}
 */
export const useEntryAccent = (kind) => {
  const { theme } = useTheme();

  if (kind.accent) return kind.accent;

  return {
    button: theme.colors.gradient.button,
    buttonHover: theme.colors.gradient.buttonHover,
    shadow: theme.colors.shadow,
    chip: 'bg-gray-100 text-gray-700',
    heroBg: theme.colors.gradient.bg,
    textMuted: theme.colors.text.muted,
  };
};

export default useEntryAccent;
